<template>
<v-row>
<v-dialog
  v-model="dialog"
  max-width="600"
  scrollable
  transition="dialog-bottom-transition"
>
  <v-card
    v-if="person"
    flat tile
    height="530"
  >

    <v-toolbar
    max-height="64"
    dark
    color="cyan"
    >
      <template slot="default">
        <v-toolbar-title>{{ person.fullname }} {{ person.positionname }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon large dark @click="close">
          <v-icon large>close</v-icon>
        </v-btn>
      </template>
    </v-toolbar>

    <v-flex>
      <v-data-table
        :headers="headers"
        :items="events"
        :footer-props="footerProps"
        no-data-text="пусто"
        no-results-text="ничего не найдено"
        :items-per-page.sync="itemsPerPage"
        class="elevation-0"
        item-key="eventid"
        dense
        flat
      >
        <template v-slot:item.originalts="{ item }">
          {{ dateFormat(item.originalts) }}
        </template>
        <template v-slot:item.direction="{ item }">
          <div :class="style(item)">
            {{ item.direction }}
          </div>
        </template>
        <template v-slot:item.person.fullname="{ item }">
          <span v-if="item.person"
          class="primary--text text--darken-3"
          style="cursor: pointer; font-size: 14px"
          @click="page = 1; personid = item.person.personid; fetch()"
          >{{ item.person.fullname }}
          </span>
        </template>
      </v-data-table>
    </v-flex>
  </v-card>
</v-dialog>
</v-row>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DialogPersonEvents',
  props: ['person', 'value'],
  data: () => ({
    dialog: false,
    events: [],
    headers: [
      { text: 'карта', value: 'cardid', width: '100' },
      { text: 'дата', value: 'originalts', },
      { text: 'напр.', value: 'direction', width: '100' },
      { text: 'место', value: 'controllername', },
    ],
    footerProps: {
      itemsPerPageText: 'Показывать:',
      itemsPerPageOptions: [15, 100]
    },
    itemsPerPage: 15,
    date: moment().format('YYYY-MM-DD'),
    day: moment().format('YYYY-MM-DD'),
  }),
  computed: {
  },
  methods: {
    close () {
      this.dialog = false
    },
    async fetch () {
      try {
        this.fetchEvents()
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async fetchEvents () {
      try {
        const { meta, events } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-events-by-personid',
          pl: {
            personid: this.person.personid,
            order: 'desc'
          }
        })
        this.events = events
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    setDay () {
      this.day = moment(this.date).format('YYYY-MM-DD')
    },
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    style (item) {
      if (item.direction === 'вход') return 'in'
      if (item.direction === 'выход') return 'out'
      if (item.direction === 'проход') return 'pass'
      return item.direction
    },
  },
  watch: {
    dialog (val) {
      this.$emit('input', val)
    },
    value (val) {
      this.dialog = val
    },
    person (val) {
      if (val) {
        this.fetch()
      }
    }
  },
}
</script>

<style lang="css">
</style>
